import React, { useEffect } from 'react';
import { useIntl } from 'react-intl-next';
import EmptyState from '@atlaskit/empty-state';
import messages from '../../messages';
import { AccessLockSVGWrapper, TeamForbiddenErrorStateWrapper } from '../../styled/TeamCard';
import { profileCardRendered } from '../../util/analytics';
import AccessLockSVG from '../Error/AccessLockSVG';
export default (function (props) {
  var analytics = props.analytics;
  var intl = useIntl();
  useEffect(function () {
    analytics(function (duration) {
      return profileCardRendered('team', 'error', {
        duration: duration
      });
    });
  }, [analytics]);
  return /*#__PURE__*/React.createElement(TeamForbiddenErrorStateWrapper, {
    "data-testid": "team-profilecard-forbidden-error-state"
  }, /*#__PURE__*/React.createElement(EmptyState, {
    header: intl.formatMessage(messages.teamForbiddenErrorStateTitle),
    description: intl.formatMessage(messages.teamForbiddenErrorStateDescription),
    renderImage: function renderImage() {
      return /*#__PURE__*/React.createElement(AccessLockSVGWrapper, null, /*#__PURE__*/React.createElement(AccessLockSVG, null));
    }
  }));
});